export const baseURL = "https://s1otvxbqbj.execute-api.ap-southeast-1.amazonaws.com/pilot"
  

